const STALE_MIN = 30;
export const isStale = (w) => !w?.observed_at || Date.now() - new Date(w.observed_at).getTime() > STALE_MIN * 60 * 1000;
